import React, {useEffect, useState} from "react";
import {collection, query, orderBy, getDocs} from "firebase/firestore";
import {firestore} from "../firebase";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";

const FestivalScoreBoard = () => {
  const [level, setLevel] = useState("e"); // 기본: 초등부
  const [list, setList] = useState([]);

  const navigate = useNavigate();

  const {currentUser} = useAuth();

  // 🔥 관리자 이메일만 접근 가능
  if (!currentUser || currentUser.email !== "aa@a.com") {
    return (
      <div className="p-5 text-center">
        <h3>접근 권한이 없습니다.</h3>
      </div>
    );
  }

  const loadLevel = async (lv) => {
    setLevel(lv);

    const q = query(
      collection(firestore, `Festival_${lv}`),
      orderBy("createdAt", "asc")
    );

    const snap = await getDocs(q);

    let arr = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // 🔥 점수순 → 등록순 정렬
    arr.sort((a, b) => {
      const scoreA = a.score ?? -1;
      const scoreB = b.score ?? -1;

      if (scoreA !== scoreB) return scoreB - scoreA;
      return (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0);
    });

    setList(arr);
  };

  useEffect(() => {
    loadLevel("e");
  }, []);

  const maskPhone = (phone) => {
    if (!phone) return "";
    const last4 = phone.slice(-4);
    return `***-****-${last4}`;
  };
  const maskEmail = (email) => {
    if (!email) return "";
    const [id, domain] = email.split("@");
    return `${id}@*****`;
  };


  return (
    <div className="container py-4 bg-white">

      <h2 className="fw-bold mb-4">초코파이썬 코딩 타자대회 스코어보드</h2>

      {/* 레벨 선택 버튼 */}
      <div className="d-flex gap-3 mb-4">
        <button
          className={`btn btn-${level === "e" ? "primary" : "outline-primary"}`}
          onClick={() => loadLevel("e")}
        >
          초등부
        </button>

        <button
          className={`btn btn-${level === "m" ? "primary" : "outline-primary"}`}
          onClick={() => loadLevel("m")}
        >
          중등부
        </button>

        <button
          className={`btn btn-${level === "h" ? "primary" : "outline-primary"}`}
          onClick={() => loadLevel("h")}
        >
          고등부
        </button>
      </div>

      {/* 참가자 표 */}
      <table className="table table-bordered table-hover text-center align-middle">
        <thead style={{backgroundColor: "#eee"}}>
          <tr>
            <th>순위</th>
            <th>이름</th>
            <th>이메일</th>
            <th>전화번호</th>
            <th>점수</th>
            <th>관리</th>
          </tr>
        </thead>

        <tbody>
          {list.map((v, idx) => (
            <tr key={v.id}>
              <td>{idx + 1}</td>
              <td>{v.name}</td>
              <td>{maskEmail(v.email)}</td>
              <td>{maskPhone(v.phone)}</td>
              <td>{v.score ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default FestivalScoreBoard;
